import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Dark Mode")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return _renderSlot(_ctx.$slots, "default", {}, () => [
    _createVNode(_component_ion_button, {
      slot: "end",
      class: "apply-dark-mode",
      fill: "clear",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openThemeModal()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_icon, {
          slot: "icon-only",
          icon: _ctx.bulbOutline
        }, null, 8, ["icon"])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_modal, {
      ref: "id",
      "initial-breakpoint": 0.25,
      breakpoints: [0, 0.25]
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_content, { class: "ion-padding" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              lines: "none",
              class: "ion-item-transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_text, { slot: "start" }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_toggle, {
                  checked: _ctx.isDarkMode,
                  onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleDarkTheme($event))),
                  slot: "end"
                }, null, 8, ["checked"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["initial-breakpoint", "breakpoints"])
  ])
}